import React, { useState, useRef } from "react";
import EditIcon from "../../../ui/EditIcon";

import { Table, Tag } from "antd";
import { formatToINR, getRandomColor } from "../../../../helpers/utility";
import PackagesForm from "./PackagesForm";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import useIsMobile from "../../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../../hooks/usePageFillTableScroll";
import styles from "../Services.module.css";

const PackageTable = ({ data, loading, refreshPackages, userDetails }) => {
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    Array.isArray(data) ? data.length : 0
  );
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const defaultRole = userDetails?.currRole || getCookie(Role);

  const columns = [
    {
      title: "Package Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Package Details",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Package Type",
      dataIndex: "package_type",
      key: "package_type",
    },
    {
      title: "Services",
      dataIndex: "package_services",
      key: "package_services",
      width: "20%",

      render: (value) =>
        value?.map((item) => {
          return (
            <Tag
              color={getRandomColor(item?.service?.name)}
              style={{ marginBottom: "4px" }}
              key={item?.investigation?.name}
            >
              {item?.service?.name}
            </Tag>
          );
        }),
    },
    // {
    //   title: "Investigations",
    //   dataIndex: "package_investigations",
    //   key: "package_investigations",
    //   width: "20%",
    //   render: (value) =>
    //     value?.map((item) => {
    //       return (
    //         <Tag
    //           color={getRandomColor(item?.investigation?.name)}
    //           style={{ marginBottom: "4px" }}
    //           key={item?.investigation?.name}
    //         >
    //           {item?.investigation?.name}
    //         </Tag>
    //       );
    //     }),
    // },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      width: isMobile ? 100 : undefined,
      render: (value) => (value ? value?.replace("_", " ") : "-"),
    },
    {
      title: "Facility",
      dataIndex: "facility_name",
      key: "facility_name",
      width: isMobile ? 120 : undefined,
      ellipsis: isMobile,
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Price (Rs)",
      dataIndex: "total_price",
      key: "total_price",
      width: isMobile ? 110 : undefined,
      render: (value) => formatToINR(value),
      sorter: (a, b) => a?.total_price - b?.total_price,
    },
    ...(defaultRole === "Receptionist" || defaultRole === "Facility_Admin"
      ? []
      : [
          {
            title: "Action",
            render: (record) => (
              <EditIcon
                onClick={() => {
                  setOpen(true);
                  setEditData(record);
                }}
              />
            ),
          },
        ]),
  ];
  return (
    <div ref={tableWrapRef} className={`${styles.servicesTableWrap} ui-table-fill-body`}>
      <Table
        className="no-vertical-borders"
        rowKey="id"
        dataSource={data || []}
        columns={columns}
        pagination={false}
        bordered
        loading={loading}
        scroll={tableScroll}
      />
      {open && (
        <PackagesForm
          visible={open}
          setVisible={setOpen}
          refreshPackages={refreshPackages}
          editData={editData}
        />
      )}
    </div>
  );
};

export default PackageTable;
